'use strict';

angular.module('scrapQcrmApp')
  .factory('telecallerService', function(httpService, $global) {
    return {
      addTelecaller: function(data) {
        var url = $global.getApiUrl() + $global.getApiObject().addTelecaller;
        return httpService.httpRequest(url, "P", data);
      },

      editTelecaller: function(data) {
        var url = $global.getApiUrl() + $global.getApiObject().editTelecaller;
        return httpService.httpRequest(url, "P", data);
      },

      getTelecallerList: function(city, page, status) {
        var url = $global.getApiUrl() + $global.getApiObject().getTelecallerList + '?city=' + city + '&page=' + (page || 0);
        if (status === 'true' || status === true) {
          url += '&status=active';
        } else if (status === 'false' || status === false) {
          url += '&status=inactive';
        }
        return httpService.httpRequest(url, "G", "");
      },

      getTelecallerProfile: function(id) {
        var url = $global.getApiUrl() + $global.getApiObject().getTelecallerProfile.replace(":id", id);
        return httpService.httpRequest(url, "G", "");
      },

      disableTelecaller: function(id) {
        var url = $global.getApiUrl() + $global.getApiObject().disableTelecaller;
        return httpService.httpRequest(url, "P", { telecallerId: id });
      },

      // TODO (Backend): POST /api/telecaller/enable — re-activate a disabled telecaller
      // Request body: { telecallerId: "TC_xxx" }
      // Response: { statusCode: 200, status: "SUCCESS" }
      enableTelecaller: function(id) {
        var url = $global.getApiUrl() + $global.getApiObject().enableTelecaller;
        return httpService.httpRequest(url, "P", { telecallerId: id });
      },

      // TODO (Backend): POST /api/telecaller/delete — permanently delete a telecaller record
      // Request body: { telecallerId: "TC_xxx" }
      // Response: { statusCode: 200, status: "SUCCESS" }
      deleteTelecaller: function(id) {
        var url = $global.getApiUrl() + $global.getApiObject().deleteTelecaller;
        return httpService.httpRequest(url, "P", { telecallerId: id });
      },

      resetPassword: function(id, newPassword) {
        var url = $global.getApiUrl() + $global.getApiObject().resetTelecallerPassword;
        return httpService.httpRequest(url, "P", { telecallerId: id, newPassword: newPassword });
      }
    };
  });
